<template>
  <div class="box">
    <h5 class="isintroduced">评审得分</h5>
    <div style="display: flex; margin: 0 auto">
      <div class="wdpf">我的评分</div>
      <el-rate v-model="wdvalue" @change="insScore"></el-rate>
    </div>
    <div class="pfys">
      <div class="pf" v-for="(item, index) in scorelist.scorelist" :key="index">
        <div
          style="
            font-weight: 400;
            font-size: 18px;
            color: #333333;
            margin-top: 5px;
            /* margin-left: 55px; */
          "
        >
          {{ item.name }}教授评分
        </div>
        <el-rate disabled size="large" v-model="item.score"></el-rate>
      </div>
    </div>
  </div>
</template>

<script>
import { insscore, selknow } from "../../../api/patient";
export default {
  data() {
    return {
      wdvalue: "0",
      scorelist: [],
    };
  },
  mounted() {
    this.selknow();
  },
  // activated() {
  //   console.log(this.$store.state.kpwzxx, "11");
  //   this.$nextTick(() => {
  //     this.scorelist = this.$store.state.kpwzxx;
  //     this.scorelist.scorelist.forEach((item) => {
  //       if (item.phone == this.$store.state.user.phone) {
  //         this.wdvalue = item.score;
  //       }
  //     });
  //   });
  // },
  methods: {
    async selknow() {
      const data = new FormData();
      data.append("id", this.$store.state.Jumpid);
      await selknow(data).then((res) => {
        this.scorelist = res;
        this.scorelist.scorelist.forEach((item) => {
          if (item.phone == this.$store.state.user.phone) {
            this.wdvalue = item.score;
          }
        });
      });
    },
    insScore() {
      this.$confirm("此操作将只能操作一次, 是否确定评分无误继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var data = new FormData();
          data.append("phone", this.$store.state.user.phone);
          data.append("kid", this.$store.state.Jumpid);
          data.append("score", this.wdvalue);
          console.log(
            this.$store.state.user.phone,
            this.$store.state.Jumpid,
            this.wdvalue
          );
          insscore(data).then((res) => {
            console.log(res);
            if ((res.code = "OK")) {
              this.selknow();
              this.$message({
                type: "success",
                message: "评分成功!",
              });
            } else {
              this.$message({
                type: "success",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消评分",
          });
        });
    },
  },
};
</script>
<style scoped>
/deep/.el-rate__icon {
  font-size: 35px;
}
</style>
<style scoped lang="scss">
.box {
  margin: 0 auto;
  width: 687px;
  min-height: 500px;
  display: flex;
  text-align: left;
  flex-direction: column;
}
.pfys {
  display: flex;
  flex-wrap: wrap;
  width: 710px;
  .pf {
    display: flex;
    transform: scale(0.8);
    width: 350px;
    margin-top: 35px;
  }
}
.isintroduced {
  margin-top: 25px;
  margin-bottom: 19px;
  text-align: left;
  padding-left: 10px;
  border-left: 2px solid #4ccaff;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
}
.wdpf {
  font-weight: bold;
  font-size: 20px;
  color: #333333;
  margin-top: 5px;
}
// 适配手机端
@media (max-width: 768px) {
  .box {
    width: 95vw;
  }
  .pfys {
    width: 95vw;
    .pf {
      width: 95vw;
    }
  }
}
</style>
